import axios from 'axios';

/**
 * Envoie le formulaire au serveur public sans dépendre d'une session Supabase.
 * Le serveur conserve la clé Brevo et choisit lui-même le destinataire du message.
 */
export async function sendContactMessage(values) {
  const origin = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const { data } = await axios.post(`${origin}/api/contact`, values, { timeout: 20000 });
  return data;
}
